module.exports = __webpack_public_path__ + "static/media/wrongData.4b8f9fb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/wrongData.png
// module id = 16
// module chunks = 2